import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=99a26d4c&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"
import style0 from "./Requirements.vue?vue&type=style&index=0&id=99a26d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a26d4c",
  null
  
)

export default component.exports